import "typeface-roboto/index.css";
import "./styles/app.css";
import "primevue/resources/themes/lara-light-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";

import { createApp } from "vue";
import PrimeVue from "primevue/config";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import UiButton from "./components/ui/UiButton.vue";
import UiRowActions from "./components/ui/UiRowActions.vue";
import UiInput from "./components/ui/UiInput.vue";
import UiSelect from "./components/ui/UiSelect.vue";
import UiTextarea from "./components/ui/UiTextarea.vue";
import UiPanel from "./components/ui/UiPanel.vue";
import UiPageHero from "./components/ui/UiPageHero.vue";
import UiModal from "./components/ui/UiModal.vue";
import UiCheckbox from "./components/ui/UiCheckbox.vue";
import UiPagination from "./components/ui/UiPagination.vue";
import UiDatePicker from "./components/ui/UiDatePicker.vue";
import { getErrorMessage, useToast } from "./utils/toast";

const app = createApp(App);
const { showToast } = useToast();

window.addEventListener("unhandledrejection", (event) => {
  event.preventDefault();
  showToast(getErrorMessage(event.reason), "error");
});

app.config.errorHandler = (error) => {
  showToast(getErrorMessage(error), "error");
};

app
  .use(PrimeVue, {
    locale: {
      accept: "Đồng ý",
      reject: "Hủy",
      choose: "Chọn",
      upload: "Tải lên",
      cancel: "Hủy",
      dayNames: [
        "Chủ nhật",
        "Thứ hai",
        "Thứ ba",
        "Thứ tư",
        "Thứ năm",
        "Thứ sáu",
        "Thứ bảy",
      ],
      dayNamesShort: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
      dayNamesMin: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
      monthNames: [
        "Tháng 1",
        "Tháng 2",
        "Tháng 3",
        "Tháng 4",
        "Tháng 5",
        "Tháng 6",
        "Tháng 7",
        "Tháng 8",
        "Tháng 9",
        "Tháng 10",
        "Tháng 11",
        "Tháng 12",
      ],
      monthNamesShort: [
        "Thg 1",
        "Thg 2",
        "Thg 3",
        "Thg 4",
        "Thg 5",
        "Thg 6",
        "Thg 7",
        "Thg 8",
        "Thg 9",
        "Thg 10",
        "Thg 11",
        "Thg 12",
      ],
      today: "Hôm nay",
      clear: "Xóa",
      weekHeader: "Tuần",
      firstDayOfWeek: 1,
      dateFormat: "dd/mm/yy",
    },
  })
  .use(store)
  .use(router)
  .component("UiButton", UiButton)
  .component("UiRowActions", UiRowActions)
  .component("UiInput", UiInput)
  .component("UiSelect", UiSelect)
  .component("UiTextarea", UiTextarea)
  .component("UiDatePicker", UiDatePicker)
  .component("UiPanel", UiPanel)
  .component("UiPageHero", UiPageHero)
  .component("UiModal", UiModal)
  .component("UiCheckbox", UiCheckbox)
  .component("UiPagination", UiPagination)
  .mount("#app");
